@if (activeQuestion$()) {
  <div [formGroup]="activeQuestion$()" class="multi-choice-settings__container">
    <empathy-required-setting [activeQuestion]="activeQuestion$()"></empathy-required-setting>
    <empathy-randomized-options-setting [activeQuestion]="activeQuestion$()"></empathy-randomized-options-setting>
    <empathy-min-view-time-setting [activeQuestion]="activeQuestion$()" [showBorder]="false"></empathy-min-view-time-setting>

    <div class="multi-choice-settings__input-containers">
      <div class="editor-question-form__input">
        <span class="label"> Min number of answer selected </span>
        <span *ngIf="activeQuestion$().value.requiredInd" class="sublabel">When question is required, the min value is 1 by default</span>

        <mat-form-field appearance="outline">
          <input matInput type="number" [min]="activeQuestion$().value.requiredInd ? 1 : 0" formControlName="minLength" />
        </mat-form-field>
      </div>

      <div class="editor-question-form__input">
        <span class="label"> Max number of answer selected </span>
        <span class="sublabel">When the value is 0 no max number of answer is set</span>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="maxLength" />
        </mat-form-field>
      </div>
    </div>

    <empathy-media-settings [activeQuestion]="surveyEditorService.surveyEditor$().activeQuestion"></empathy-media-settings>

    @if (activeQuestion$().get('cards')) {
      <empathy-cards-settings [activeQuestion]="activeQuestion$()"></empathy-cards-settings>
    }

    <empathy-choice-settings [activeQuestion]="activeQuestion$()"></empathy-choice-settings>
  </div>
}
